import React, { useRef } from "react";
import status from "../../../asset/images/Statustick.svg";


function Confirmation({ onNewUpload, handleTabChange, confirmationData }) {

    const {
    batchId,
    type,
    } = confirmationData || {};

    return (
        <div className="step-content">
            <div className="upload-box">
                <div className="wrap-content-upload">
                    <span className="upload-text">Confirmation</span>

                    <div className="conf-content">

                        <div className="upload-area">
                            <img src={status} alt="status icon" />

                            <div className="wrap-input-cont">
                                <span className="drag-text">
                                    {type?.toLowerCase() === "draft"
                                        ? "Saved as Draft!"
                                        : "Submission Successful!"}
                                </span>


                                <div className="info-banner width-banner">
                                    <span>
                                        {type?.toLowerCase() === "draft"
                                            ? "Draft ID:"
                                            : "Service Request ID:"}
                                    </span>

                                    <span className="ids">
                                        {batchId}
                                    </span>
                                </div>

                                <div className="footer-actions conf-footer">
                                    <button className="back-btn" onClick={() => handleTabChange("myReq")}>
                                        MY REQUESTS
                                    </button>
                                    <button className="submit-btns" onClick={() => onNewUpload()}>NEW MAPPING REQUESTS</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default Confirmation;